// extracted by mini-css-extract-plugin
export default {"container":"WarehouseScanner_container__-uDxK","divider":"WarehouseScanner_divider__9wO+I"};